/* @ngInject */
export default function ($scope, LayoutService, TrainingModules, toastr, $state, $stateParams, TrainingCourses,
                         PermissionsGates, PermissionsCategories, PermissionsUsers, PermissionsServiceUsers, $q) {
	$scope.courseId = $stateParams.courseId;

	$scope.module = {
		title:               '',
		identifier:          '',
		description:         '',
		available:           true,
		sort:                0,
		requiredPermissions: [],
	};

	$scope.permissionTypes = {
		'gate':        'Gate',
		'category':    'Category',
		'user':        'User',
		'serviceUser': 'Service User',
		'public':      'Public Access',
	};

	$scope.refresh = () => {
		$scope.loading = true;

		$q.all([
			  PermissionsGates.getList(),
			  PermissionsCategories.getList(),
			  PermissionsUsers.getList({
				  include: 'workable',
			  }),
			  PermissionsServiceUsers.getList(),
		  ])
		  .then((results) => {
			  const permissionsGates        = results[0];
			  const permissionsCategories   = results[1];
			  const permissionsUsers        = results[2];
			  const permissionsServiceUsers = results[3];

			  const statusGroups = {
				  0: 'Inactive',
				  1: 'Active',
				  2: 'Finished',
			  };

			  $scope.permissionsGates        = permissionsGates;
			  $scope.permissionsCategories   = permissionsCategories;
			  $scope.permissionsUsers        = permissionsUsers;
			  $scope.permissionsServiceUsers = permissionsServiceUsers.map((serviceUser) => {
				  return {
					  ...serviceUser,
					  shortCode:   (serviceUser.shortCode) ? ('SU#' + serviceUser.shortCode) : ('N/A'),
					  statusGroup: statusGroups[serviceUser.status],
				  };
			  });

		  })
		  .catch((error) => {
			  toastr.clear();
			  toastr.error('There was an error while loading this page, please try again.', 'Error');

			  $state.go('staff.training.management.view', {
				  courseId: $scope.courseId,
			  });

			  $scope.loading = false;
		  });

		TrainingCourses.one($scope.courseId)
		               .get()
		               .then((course) => {
			               $scope.course  = course;
			               $scope.loading = false;

			               $scope.updateLayout($scope.course.name);
		               })
		               .catch((error) => {
			               toastr.clear();
			               toastr.error('There was an error while loading this module, please try again.', 'Error');

			               $state.go('staff.training.management.view', {
				               courseId: $scope.courseId,
			               });

			               $scope.loading = false;
		               });
	};

	$scope.save = () => {
		const module = {
			title:               $scope.module.title,
			identifier:          $scope.module.identifier,
			description:         $scope.module.description,
			available:           $scope.module.available,
			sort:                $scope.module.sort,
			requiredPermissions: $scope.module.requiredPermissions.filter((permission) => {
				switch (permission.type) {
					case 'gate': {
						return permission.gate;
					}

					case 'category': {
						return permission.category;
					}

					case 'user': {
						return permission.user;
					}

					case 'serviceUser': {
						return permission.serviceUser;
					}

					case 'public': {
						return true;
					}

					default: {
						return false;
					}
				}
			}),
		};

		TrainingCourses.one($scope.courseId)
		               .post('modules', module)
		               .then((returnedModule) => {
			               toastr.clear();
			               toastr.success('The module was successfully created.', 'Module Created');

			               $state.go('staff.training.management.view', {
				               courseId: $scope.courseId,
			               });
		               })
		               .catch((error) => {
			               toastr.clear();
			               toastr.error('There was an error while creating the module, please try again.', 'Error');
		               });
	};

	$scope.addPermission = () => {
		$scope.module.requiredPermissions.push({
			type:        '',
			gate:        null,
			category:    null,
			user:        null,
			serviceUser: null,
		});
	};

	$scope.removePermission = (index) => {
		$scope.module.requiredPermissions.splice(index, 1);
	};

	$scope.resetPermission = (index) => {
		$scope.module.requiredPermissions[index] = {
			...$scope.module.requiredPermissions[index],
			gate:        null,
			category:    null,
			user:        null,
			serviceUser: null,
		};
	};

	$scope.updateLayout = (courseName = 'Loading...') => {
		LayoutService.reset();

		LayoutService.setTitle([
			'New Module',
			courseName,
			'Management',
			'Training',
		]);

		LayoutService.getPageHeader()
		             .setBreadcrumbs([
			             {
				             route:       'staff.dashboard',
				             displayName: 'Dashboard',
			             },
			             {
				             route:       'staff.training.root',
				             displayName: 'Training',
			             },
			             {
				             route:       'staff.training.management.root',
				             displayName: 'Management',
			             },
			             {
				             route:       `staff.training.management.view({ courseId: "${$scope.courseId}" })`,
				             displayName: courseName,
			             },
			             {
				             route:       `staff.training.management.modules.new({ courseId: "${$scope.courseId}" })`,
				             displayName: 'New Module',
			             },
		             ]);

		LayoutService.getPageHeader()
		             .setActionButton('<button type="button" class="btn btn-primary pull-right"><i class="fa fa-check"></i> Save</button>');

		LayoutService.getPageHeader()
		             .onClicked($scope.save);
	};

	$scope.updateLayout();
	$scope.refresh();
};


// WEBPACK FOOTER //
// ./src/js/endpoints/staff/training/management/modules/new/controller.js